<script setup>
import Updates from "@/views/enterprise/home/aside/updates/Updates.vue";
import CompanyDetails from "@/views/enterprise/home/aside/CompanyDetails.vue";
import { useStore } from "vue2-helpers/vuex";
import { inject } from "vue";

const store = useStore();
const collapsed = inject('asideCollapsed');

const toggleCollapsed = () => {
    collapsed.value = !collapsed.value;
};
</script>

<template>
    <aside class="aside aside--homepage" :class="{ 'aside--collapsed': collapsed }">
        <a v-if="store.getters.isDaikinEnterprise" @click="toggleCollapsed" class="aside__collapse"></a>
        <div class="aside__inner">
            <div
                class="aside__inner__section"
                :class="{'no-radius': store.getters.isDaikinEnterprise}"
            >
                <CompanyDetails/>
            </div>
            <div
                v-if="store.getters.isPremiumEnterprise"
                class="aside__inner__section"
            >
                <Updates/>
            </div>
        </div>
    </aside>
</template>

<style scoped>
    .aside {
        position: relative;
        flex: 0 0 474px !important;
        width: 474px;
        background-color: inherit !important;
        box-shadow: inherit !important;
        padding: 30px 0 0 0 !important;
        overflow: visible !important;

        &.aside--collapsed {
            flex: 0 0 0px !important;
            width: 0;

            .aside__collapse {
                left: -120px;
                flex: 0 0 120px;
                width: 120px;

                &::before {
                    transform: rotate(0deg);
                }
                &:after {
                    content: "Updates";
                }
            }

        }
        .aside__collapse {
            position: absolute;
            left: -50px;
            top: 0;
            display: flex;
            align-items: center;
            justify-content: center;
            width: 50px;
            height: 53px;
            background: #016d94;
            border-radius: 26px 0 0 26px;
            cursor: pointer;

            margin-top: 31px;
            z-index: -1;

            &::before {
                content: "";
                position: relative;
                top: -2px;
                display: block;
                width: 12px;
                height: 12px;
                background: url('../../../../images/minimize.svg') no-repeat center;
                background-size: auto 12px;
                transform: rotate(180deg);
                transition: transform 0.6s;
            }
            &:hover {
                text-decoration: none;
            }
        }

        .aside__inner {
            flex: 0 0 432px;
            width: 432px;

            .aside__inner__section {
                background-color: #fff;
                font-weight: bold;
                border-radius: 10px;
                border: solid 1px #ddd;

                &.no-radius {
                    border-top-left-radius: 0;
                }
            }
        }
    }
</style>
